<div class="otp-modal-container">
    <div class="header-otp">
        <h2 class="m-0">Verificación de seguridad</h2>
        <p>Hemos enviado un código de 6 dígitos al número
            <b>+{{data.phone}}</b></p>
    </div>

    <form [formGroup]="otpForm" class="otp-inputs-row"
        (paste.capture)="onPaste($event)">
        <ng-container formArrayName="digits">
            <input
                #otpInput
                *ngFor="let control of digits.controls; let i = index"
                [formControlName]="i"
                type="text"
                inputmode="numeric"
                maxlength="1"
                (keydown)="onKeyDown($event, i)"
                (input)="onInput(i)"
                (focus)="handleFocus(i)"
                (paste)="onPaste($event)"
                autocomplete="one-time-code" />
        </ng-container>
    </form>

    <div class="error-otp-container" *ngIf="errorMessage">
        <div class="error-box">
            <i class="fa-light fa-circle-exclamation"></i>
            <span>{{ errorMessage }}</span>
        </div>
    </div>

    <div class="timer-section">
        <p *ngIf="!canResend">Podrás solicitar un nuevo código en: <b>0:{{ timer
                | number: '2.0-0' }}</b></p>
        <p *ngIf="canResend" class="resend-link" (click)="resendCode()">
            <i class="fa-light fa-arrow-rotate-right"></i> Volver a enviar
            código
        </p>
    </div>

    <div class="actions-otp">
        <button class="pink-button solid w-100"
            [disabled]="otpForm.invalid || loading"
            (click)="verify()">
            <i class="fa-light"
                [ngClass]="loading ? 'fa-spinner fa-spin' : 'fa-check'"></i>
            {{ loading ? 'Verificando...' : 'Validar teléfono' }}
        </button>
        <p class="cancel-link" (click)="close()">Cancelar</p>
    </div>
</div>